import React from 'react';
import ConversationList from './ConversationList/ConversationList';
import MessageThread from './MessageThread/MessageThread';
import MessageInput from './MessageInput/MessageInput';
import styles from '../WabaChats.module.scss';
import { isWindowOpen } from '../windowStatus';

export default function WabaChats({
    conversations, conversationsStatus, activeConversationId,
    messages, messagesStatus, hasMoreMessages,
    onSelectConversation, onSendMessage, onLoadMore,
    branchId, onDismiss, onSendMedia,
}) {
    const activeConversation = conversations.find(c => c.id === activeConversationId);
    const canReply = activeConversation ? isWindowOpen(activeConversation) : false;
    return (
        <div className={styles.wrapper}>
        <div className={styles.container}>
            <div className={styles.sidebar}>
                <ConversationList
                    conversations={conversations}
                    activeConversationId={activeConversationId}
                    status={conversationsStatus}
                    onSelect={onSelectConversation}
                />
            </div>
            <div className={styles.main}>
                {activeConversationId ? (
                    <>
                        <div className={styles.header}>
                            <div className={styles.headerName}>
                                {activeConversation?.customer_name || activeConversation?.customer_phone}
                            </div>
                            <div className={styles.headerPhone}>{activeConversation?.customer_phone}</div>
                        </div>
                        <MessageThread
                            messages={messages}
                            status={messagesStatus}
                            hasMore={hasMoreMessages}
                            onLoadMore={onLoadMore}
                            branchId={branchId}
                            onDismiss={onDismiss}
                        />
                        {!canReply && (
                            <div className={styles.windowWarning}>
                                <span className={styles.windowWarningIcon}>!</span>
                                <span>
                                    Прошло более 24 часов с последнего сообщения клиента. По правилам WhatsApp обычное
                                    сообщение отправить нельзя — дождитесь нового сообщения от клиента или ответьте с телефона.
                                </span>
                            </div>
                        )}
                        <MessageInput onSend={onSendMessage} onSendMedia={onSendMedia} disabled={!canReply} />
                    </>
                ) : (
                    <div className={styles.emptyState}><p>Выберите диалог, чтобы начать переписку</p></div>
                )}
            </div>
        </div>
        </div>
    );
}
